type GtagFn = (...args: unknown[]) => void

function gtag(): GtagFn | null {
  const w = window as unknown as Record<string, unknown>
  if (typeof w.gtag === 'function') return w.gtag as GtagFn
  if (typeof w.dataLayer !== 'undefined' && Array.isArray(w.dataLayer)) {
    return (...args: unknown[]) => (w.dataLayer as unknown[]).push(args)
  }
  return null
}

function send(eventName: string, params?: Record<string, unknown>) {
  const fn = gtag()
  if (!fn) return
  fn('event', eventName, params)
}

export const analytics = {
  chatOpened: () =>
    send('larte_chat_open'),

  chatClosed: () =>
    send('larte_chat_close'),

  messageSent: (hasFiles: boolean) =>
    send('larte_message_sent', { has_files: hasFiles }),

  photoUploaded: (count: number) =>
    send('larte_photo_upload', { photo_count: count }),

  quickQuestionClicked: (question: string) =>
    send('larte_quick_question', { question }),

  actionButtonClicked: (buttonId: string) =>
    send('larte_action_button', { button_id: buttonId }),

  leadFormShown: (reason?: string) =>
    send('larte_lead_form_shown', { reason }),

  leadFormSubmitted: (channel?: string) =>
    send('larte_lead_form_submit', { preferred_channel: channel }),

  newConversation: () =>
    send('larte_new_conversation'),

  aiResponseReceived: (hasButtons: boolean, hasFallback: boolean) =>
    send('larte_ai_response', { has_buttons: hasButtons, has_fallback: hasFallback }),
}
